<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card>
					<el-row>
						<el-page-header @back="goBack" content="上一页" v-show="returnBtn" >
						</el-page-header>
					</el-row>
					<el-row :gutter="50">
						<el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" v-for="(item,index) in menuList" :key="index"
							@click.native="goChild(item)">
							<div class="menuBox">
								<div class="menuIcon">
									<img :src="settings.apiBaseImg+item.icont" alt="">
								</div>
								<div class="menuTitle">
									{{item.columname}}
								</div>
							</div>
						</el-col>
					</el-row>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				menuList: [],
				returnBtn:false
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData() {
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v2/column/menu',
				}).then((res) => {
					if (res.data.status == 200) {
						this.menuList = res.data.data.columnMenuList
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			goChild(item) {
				if (item.columnMenuList == null) {
					this.$router.push({
						path: item.routeName,
						query: {
							id: item.id
						}
					})
					this.$store.commit('selectMenu', item)
				} else {
					this.returnBtn = true
					var obj = this
					obj.$http({
						method: 'get',
						url: 'api/v2/column/menu',
						params: {
							pid: item.id
						},
					}).then((res) => {
						if (res.data.status == 200) {
							this.$router.push({
								path: item.path,
								id: item.id
							})
							this.menuList = res.data.data.columnMenuList
						} else {
							obj.$message.error(res.data.message)
						}
					})
				}

			},
			goBack() {
				if (this.$route.query.id != undefined) {
					this.returnBtn = false
					return;
				} else {
					this.$router.go(-1)
					this.getData()
				}

			}

		},
	}
</script>

<style scoped="scoped">
	.menuBox {
		height: 120px;
		background: #FFFFFF;
		border-radius: 15px;
		background-size: 100% 100%;
		margin-bottom: 20px;
		transition: all 0.3s;
		cursor: pointer;
		border: 1px solid rgba(64,62,104,0.2);
	}

	.menuIcon {
		width: 40%;
		height: 100%;
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: all .3s linear;
	}

	.menuIcon img {
		width: 40%;
		height: 50%;
	}

	.menuTitle {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 50%;
		height: 100%;
		float: left;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #808080;
		transition: all 0.3s;
	}

	.menuBox:hover {
		transition: all 0.6;
		border: 1px solid #403E68;
		box-shadow: 0 2px 15px 0 rgb(0 0 0 / 10%)
	}

	.menuBox:hover .menuIcon {
		transition: all .3s linear;
		transform: scale(0.8);
	}

	.menuBox:hover .menuTitle {
		color: #3D3D63;
		transition: all 0.3s;
	}
	/deep/ .el-page-header{
		margin-bottom: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/content/content.vue